
<!--
 * @Author: 陈远锋
 * @Date: 2022-03-07 15:26:22
 * @LastEditTime: 2022-12-09 09:48:47
 * @FilePath: \qyOut\src\pages\coupon\index.vue
 * @Description: Do not edit
-->
<template>
  <div>
    <Breadcrumb :style="{ margin: '20px 10px' }">
      <BreadcrumbItem>电子券管理</BreadcrumbItem>
      <BreadcrumbItem>券订单列表</BreadcrumbItem>
    </Breadcrumb>
    <loading :loading="loading" :error="error"></loading>

    <Form ref="selectForm" :model="selectForm" inline>
      <FormItem prop="phone">
        <Input v-model="selectForm.phone" placeholder="手机号" clearable ></Input>
      </FormItem>
      <FormItem prop="box_order_no">
        <Input
          v-model="selectForm.box_order_no"
          placeholder="三方订单号"
          clearable
        ></Input>
      </FormItem>
      <FormItem prop="flow_no">
        <Input
          v-model="selectForm.flow_no"
          placeholder="第三方流水号"
          clearable
        ></Input>
      </FormItem>
        <FormItem prop="status">
        <Select 
          v-model="selectForm.status" 
          clearable 
          placeholder="请选择状态"
          style="width: 150px; margin-right: 10px"
        >
          <Option value="0">待请求</Option>
          <Option value="1">已请求</Option>
          <Option value="2">已发券</Option>
          <Option value="3">已废弃</Option>
        </Select>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="goSelect()">查询</Button>
      </FormItem>
    </Form>
    <Table border stripe :columns="columns1" :data="coupons">
      <template slot-scope="{ row }" slot="alias">
        {{ row.coupon_category.title }}
      </template>
      <template slot-scope="{ row }" slot="is_reissue">
        <Tag :color="row.p_voucher ? 'green' : 'red'">
          {{ row.p_voucher ? '是' : '否' }}
        </Tag>
      </template>
      <template slot-scope="{ row }" slot="status">
  <span>
    {{ 
      row.status == 0 ? '待请求' : 
      row.status == 1 ? '已请求' : 
      row.status == 2 ? '已发券' : 
      row.status == 3 ? '已废弃' : '未知状态' 
    }}
  </span>
</template>
      <template slot-scope="{ row, index }" slot="action">
        <Button
          type="primary"
          size="small"
          style="margin-right: 5px"
          @click="show(row, index)"
          >发送券订单</Button
        >
      </template>
    </Table>
    <Page
      style="margin: 10px; text-align: center"
      @on-change="pageOnChange"
      :total="pages.total"
      :page-size="pages.per_page"
      :current="pages.current_page"
      show-total
      show-elevator
      prev-text="上一页"
      next-text="下一页"
    />
    <Modal
      v-model="reissueModalVisible"
      title="确认发送"
      @on-ok="confirmReissue"
      @on-cancel="cancelReissue"
    >
      <p v-if="currentReissueItem" style="margin-top: 10px;">
        <strong>三方订单号:</strong>{{ currentReissueItem.box_order_no }}<br>
        <strong>手机号：</strong>{{ currentReissueItem.phone }}<br>
      </p>
    </Modal>
  </div>
</template>
<script>
// import Dropdown from "../member/components/dropdown.vue";
import loading from "../loading.vue";
export default {
  components: {  loading },
  data() {
    return {
      companies: [],
      categories: null,
      deleteModal: false,
      deleteObj: {
        id: 0,
      },
      loading: false,
      error: null,
      coupons: [],
      pages: {
        total: 0,
        path: "",
        links: [],
      },
      selectForm: {
        phone:'',
        flow_no:'',
        box_order_no: "",
        status:''
      },
      columns1: [
        { align: "center", title: "ID", key: "id", minWidth: 100 },
        { align: "center", title: '批次', key: 'batch_no', minWidth:250 },
        { align: "center", title: "三方订单号", key: "box_order_no", minWidth: 150 },
        { align: "center", title: "名称", slot: "alias", minWidth: 200 },
        { align: "center", title: "手机号", key: "phone", minWidth: 150 },
        {
          align: "center",
          title: "发券时间",
          key: "created_at",
          minWidth: 250,
        },
        { align: "center", title: "第三方流水号", key: "flow_no", minWidth: 150 },
        { 
          align: "center", 
          title: "是否补发", 
          slot: "is_reissue", 
          minWidth: 150,
        },
        { align: "center", title: "补发原券码", key: "p_voucher", minWidth: 150 },
        { align: "center", title: "状态", slot: "status", minWidth: 80 },
        {
          title: "操作",
          slot: "action",
          width: 250,
          align: "center",
        },
      ],
      copyValue: "",
      lastSearchQuery: "", // 保存搜索词
      reissueModalVisible: false,
      currentReissueItem: null,
    };
  },
  created() {
    if (this.$route.params.page) {
      let url = "coupons/orderList?page=" + this.$route.params.page;
      delete this.$route.params.page;
      this.selectForm = this.$route.params;
      this.fetchData(url, this.$route.params);
    } else {
      this.fetchData();
    }
    this.axios.get("company").then((res) => {
      console.log("res", res);
      this.companies = res.data.companies;
      this.loading = false;
    });
    this.axios.get("coupons/orderList").then((res) => {
      console.log("resliat", res);
      this.categories = res.data.coupon_categories;
      this.loading = false;
    });
  },
  methods: {
    // 搜索框
    handleInput(e) {
      this.lastSearchQuery = e;
    },
    handleSelectChange() {
      let input = this.lastSearchQuery;
      setTimeout(() => {
        this.$refs.select.setQuery(input);
      }, 300);
    },
    goSelect: function () {
      this.fetchData("coupons/orderList", this.selectForm);
    },
    pageOnChange: function (page) {
      this.pages.links.forEach((link) => {
        if (link.label == page) {
          this.fetchData(link.url);
          return;
        }
      });
      let url =
        this.pages.path.indexOf("?") > 0
          ? this.pages.path + "&page=" + page
          : this.pages.path + "?page=" + page;
      console.log("url=>", url);
      this.fetchData(url, this.selectForm);
    },
    dateOnChange(date) {
      console.log("date", date);
      this.selectForm.start_date = date[0];
      this.selectForm.end_date = date[1];
      this.fetchData("coupons/orderList", this.selectForm);
    },
    fetchData(url = "coupons/orderList", params = {}) {
      let data = {};
      for (let key in params) {
        console.log("param[key],", params[key]);
        if (params[key] === undefined || params[key].length == 0) {
          delete params[key];
        }
      }
      data.params = params;
      this.axios.get(url, data).then((res) => {
        this.coupons = res.data.orders;
        this.pages = res.data.meta;
        console.log("this.pages=>", this.pages);
      });
    },
    dropDownClick(e) {
      this.selectForm.company_id = e.id;
      this.selectForm.company_name = e.company_name;
    },
    show(row) {
      this.currentReissueItem = row;
      this.reissueModalVisible = true;
    },
    // 确认
    confirmReissue() {
      if (!this.currentReissueItem) return;
      
      this.axios.get(`coupons/sendOrder/${this.currentReissueItem.id}`)
        .then(() => {
          this.$Message.success("发送成功");
          
          // 刷新当前页数据
          this.fetchData("coupons/orderList", this.selectForm);
          
          this.reissueModalVisible = false;
          this.currentReissueItem = null;
        })
        .catch(err => {
          console.error("发送失败", err);
          this.$Message.error(err.message || "发送失败，请重试");
        });
    },
    
    // 取消补发
    cancelReissue() {
      this.reissueModalVisible = false;
      this.currentReissueItem = null;
    }
  },
};
</script>
